import { useTranslation } from 'react-i18next';
import { TranslatedCalling } from './common';

function CalendarDayResult({ result }: { result: any }) {
  const { t } = useTranslation('chat');
  return (
    <div className="my-4 text-sm text-gray-700 bg-gray-50 p-3 rounded-md border border-gray-200 relative">
      <div className="font-medium mb-1">{t('tool.fetch-current-marketing-calendar-day.todays-plan')}</div>
      <div>
        <div className="text-gray-800">{result}</div>
      </div>
    </div>
  );
}

export const fetch_current_marketing_calendar_day = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.fetch-current-marketing-calendar-day.fetching" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.fetch-current-marketing-calendar-day.fetching" />,
  result: (toolCall: any) => <CalendarDayResult result={toolCall.result} />,
};
